import { Grid } from '@mui/material';
import Logo from 'pages/signup/components/Logo';
import MiddleContent from 'pages/signup/components/MiddleContent';
import { signupContentStyles } from 'pages/signup/components/styles';
import { useInvokeApi } from 'pages/signup/utils/useInvokeApi';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AppState } from 'store';
import Label16 from 'theme/labels/Label16';
import MainButton from 'theme/MainButton';
import {
    CLICK_CONGRATS_PAGE_RESEND_BTN,
    CLICK_CONGRATS_PAGE_SIGN_IN_BTN,
    VIEW_CONGRATS_PAGE,
} from 'utils/clevertapEvents';
import { pushEvent } from 'utils/clevertapUtils';
import { webConfig } from 'webConfig';
import Typography from '@material-ui/core/Typography';
import { useStyles } from './style';
import { GetResendText } from './GetResendText';
import { PATH } from 'routes';

export const pushGivelifySignIn = () => {
    pushEvent(CLICK_CONGRATS_PAGE_SIGN_IN_BTN, {
        gp_signup_verification_ui: 'off',
    });
    window.location.href = webConfig.givelifySignInPageUrl;
};

export const ViewV1: React.FC<any> = () => {
    const { t } = useTranslation();
    const push = useNavigate();
    const [resend, makeRequest] = useInvokeApi();
    const { logo, buttonStyles, emailText } = useStyles();
    const { content } = signupContentStyles();
    const { userEmail } = useSelector((state: AppState) => ({
        userEmail: state.Signup.userEmail,
    }));

    useEffect(() => {
        pushEvent(VIEW_CONGRATS_PAGE, { gp_signup_verification_ui: 'off' });
    }, []);

    const onResend = () => {
        pushEvent(CLICK_CONGRATS_PAGE_RESEND_BTN, {
            gp_signup_verification_ui: 'off',
        });
        makeRequest('POST', 'signup/resend-verification', {
            email: userEmail,
        });
    };

    if (!userEmail) {
        push(PATH.SIGNUP.HOME);
        return null;
    }

    return (
        <Grid container className={content}>
            <Grid item className="top-grid">
                <MiddleContent
                    heading={undefined}
                    topNode={<Logo className={logo} />}
                >
                    <Typography variant="h1">
                        {t('signup.submitted.heading')}
                    </Typography>
                    <Label16>{t('signup.submitted.body')}</Label16>
                    <MainButton
                        text={t('labels.continueToSignIn')}
                        onClick={pushGivelifySignIn}
                        className={buttonStyles}
                    />
                    <div className={emailText}>
                        {t('signup.submitted.emailTextPart1')}
                        <span className="click-here-text" onClick={onResend}>
                            {t('signup.submitted.clickHere')}
                        </span>
                        {t('signup.submitted.emailTextPart2')}
                    </div>
                    <GetResendText state={resend} email={{ userEmail }} />
                </MiddleContent>
            </Grid>
        </Grid>
    );
};
